import React, { useMemo, useState } from 'react';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import Button from '../../../../../muiComponents/Button';
import { STATUS_KEYS } from '../../../utils/zitoneoServicesUtils';
import useTranslate from '../../../../../customHooks/useTranslate';
import UnsavedServicesChangesPopUp from '../header/UnsavedServicesChangesPopUp';

const ChangeStatusButton = ({ isLoading }: { isLoading: boolean }) => {
    const { ZitoneoPublishStatusKey, hasUnsavedChanges, handleChangeStatus } =
        useZitoneoServices();
    const translate = useTranslate();
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const buttonText = useMemo(() => {
        switch (ZitoneoPublishStatusKey) {
            case STATUS_KEYS.DRAFT:
                return 'publish';
            case STATUS_KEYS.PUBLISHED:
                return 'revert_to_draft';
            default:
                return '';
        }
    }, [ZitoneoPublishStatusKey]);

    const buttonIcon = useMemo(() => {
        switch (ZitoneoPublishStatusKey) {
            case STATUS_KEYS.DRAFT:
                return 'SendOutlined';
            case STATUS_KEYS.PUBLISHED:
                return 'Pause';
            default:
                return '';
        }
    }, [ZitoneoPublishStatusKey]);

    const buttonColor = useMemo(() => {
        switch (ZitoneoPublishStatusKey) {
            case STATUS_KEYS.DRAFT:
                return 'primary';
            case STATUS_KEYS.PUBLISHED:
                return 'secondary';
            default:
                return 'inherit';
        }
    }, [ZitoneoPublishStatusKey]);

    if (ZitoneoPublishStatusKey === STATUS_KEYS.NOT_STARTED) {
        return null;
    }

    const handleClickButton = () => {
        if (
            ZitoneoPublishStatusKey === STATUS_KEYS.DRAFT &&
            hasUnsavedChanges
        ) {
            setIsWarningOpen(true);
            return;
        }
        handleChangeStatus();
    };

    return (
        <>
            <Button
                variant='outlined'
                startIcon={buttonIcon}
                className='white-space-nowrap'
                color={buttonColor}
                onClick={() => handleClickButton()}
                disabled={isLoading}
            >
                {translate(buttonText)}
            </Button>
            <UnsavedServicesChangesPopUp
                isOpen={isWarningOpen}
                onClose={() => {
                    setIsWarningOpen(false);
                }}
                onSave={async () => {
                    await handleChangeStatus();
                    setIsWarningOpen(false);
                }}
            />
        </>
    );
};

export default ChangeStatusButton;
